import { useMatches } from 'react-router';

import type { DealsPagePropsSerialized } from '@shared/types/deals-page-props';
import type { DetailsPagePropsSerialized } from '@shared/types/details-page-props';
import type { SearchPagePropsSerialized } from '@shared/types/search-page-props';

type RouteData = {
  props:
    | DealsPagePropsSerialized
    | SearchPagePropsSerialized
    | DetailsPagePropsSerialized;
};

export const useStaticMapsUrls = () => {
  const matches = useMatches();
  const { props } = matches[matches.length - 1].data as RouteData;
  if ('staticMapsUrls' in props) {
    return props.staticMapsUrls;
  }

  return null;
};
